import * as C from '../constants';
import { get, post } from '../utils/requests';
import { getPath } from '../utils/helpers';
import queryString from 'query-string';

export function storeData(payload: any, type: string) {
  return {
    payload,
    type,
  };
}

export function setLanguage(payload) {
  return {
    type: C.SET_LANGUAGE,
    payload,
  };
}

export function storeError(payload: string) {
  return {
    type: C.STORE_ERROR,
    payload,
  };
}

export function closeError() {
  return {
    type: C.CLOSE_ERROR,
  };
}

export function clearData(type: string, payload = null) {
  return {
    type,
    payload,
  };
}

export function showSuccess(payload = null) {
  return {
    type: C.SHOW_SUCCESS,
    payload,
  };
}

export function showLoginPopup() {
  return {
    type: C.SHOW_LOGIN,
  };
}

export function hideLoginPopup() {
  return {
    type: C.HIDE_LOGIN,
  };
}

export function fetchData(type, params): any {
  const paramString = queryString.stringify(params);

  return (dispatch, getState) => {
    const urlPrefix = getPath();
    const url = `${urlPrefix}/api?${paramString}`;

    if (params?.themes) {
      const app = getState().app;

      if (app?.themesData) {
        return {};
      }
    }

    return get(url)
      .then(({ data }) => {
        return dispatch(storeData(data, type));
      })
      .catch((error) => {
        // const errorData: IError = error.response && error.response.data;
        // return dispatch(throwGlobalError(errorData));
      });
  };
}

export function sendFormData(formData): any {
  return (dispatch, getState): any => {
    const urlPrefix = getPath();
    const url = `${urlPrefix}/upload`;

    return post(url, formData, {})
      .then((data): any => {
        return data;
      })
      .catch((error): any => {
        return 'error';
        // const errorData: IError = error.response && error.response.data;
        // return dispatch(throwGlobalError(errorData));
      });
  };
}

export function storeDraftsData(payload) {
  return {
    type: C.DRAFTS_DATA,
    payload,
  };
}

export function storeAuthData(payload) {
  return {
    type: C.AUTH_DATA,
    payload,
  };
}
